<template>


<v-container>
    <v-row>
        <v-col  align="center">
            {{ title }}
            <div>
            <v-progress-circular
            v-if="isallow"
            :indeterminate="true"
            color="green"
            :size="100"
            >
            </v-progress-circular>
            <div>{{ message }}</div>
            </div>

        </v-col>
    </v-row>
</v-container>

</template>

<script>

export default {
  name: "publicAccess",

  components: {
  },

  data: function () {
    return {
      dialog: true,
      title : 'Initialisation des pages',
      message : '',
      isallow : true,
      tab: 0,
    };
  },

  methods: {


  },


  created() {

    if(localStorage.getItem('tokenMinu')) {
      localStorage.removeItem('tokenMinu');
      window.location.reload(); 
    }

    if(!this.$route.params.token) {
        this.title = "une erreur est survenue";
        return
    }
                this.$store.dispatch('getoverlay',true);
                this.API({type:'get', url:'/pa/'+this.$route.params.token, params:{}}).then((resp) => {

                    if(resp.data.success) {

                        this.message = resp.data.access

                    } else {
                        this.message = resp.data.message
                        this.isallow = false;
                        return;
                    }

                    //intégration des pages dans le routeur et redirection vers la page par defaut
                    localStorage.setItem('tokenMinu',resp.data.token)
                    localStorage.setItem('firstConnect',true)
                
                    let defaultpage = resp.data.defaultpage;

                    this.$root.checkConnectionAndEnter(defaultpage)
            })


  },
};
</script>
